import { Grid, Stack, Avatar } from '@mui/material';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useNavigate } from 'react-router-dom';
import { IJob } from 'wisestep-api';
import { BottomActionBar, WsColors, WsTypography, WsTypoColors, WsButton } from 'wisestep-base';

import ErrorLogger from '../../../../../providers/ErrorLogger';
import useJobsStore from '../../hooks/useJobsStore';

export interface JobsBottomActionBarProps {
  jobListArr: (IJob & { isSelected: boolean })[];
}

const JobsBottomActionBar = ({ jobListArr }: JobsBottomActionBarProps) => {
  const navigate = useNavigate();
  const navigateToBulkJobsAssign = () => navigate('/jobs/bulk-assign');
  const navigateToBulkPublish = () => navigate('');
  const navigateToVendorBroadcast = () => {
    localStorage.setItem('jobsData', JSON.stringify(selectedJobs));
    navigate('/vendors');
  };

  const selectedJobs = useJobsStore((state) => state.jobs);
  const setBulkJobs = useJobsStore((state) => state.updateSelectedJobs);
  const unSelectJob = useJobsStore((state) => state.removeSelectedJob);

  const selectAllJobs = () =>
    jobListArr.forEach((job) => {
      if (!job.isSelected) setBulkJobs(job);
      job.isSelected = true;
    });

  const unSelectAllJobs = () =>
    jobListArr.forEach((job) => {
      unSelectJob(job);
      job.isSelected = false;
    });

  return (
    <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
      <BottomActionBar>
        <Grid item xs={6}>
          <Stack direction="row">
            <Grid item pr={1}>
              <Stack direction="row">
                <Grid item pr={0.5}>
                  <Avatar
                    variant="square"
                    sx={{ bgcolor: WsColors.TheBlues400, width: 24, height: 24 }}
                  >
                    <WsTypography color={WsTypoColors.WHITE}>{selectedJobs.length}</WsTypography>
                  </Avatar>
                </Grid>
                <Grid item>
                  <WsTypography color={WsTypoColors.PRIMARY}>Job(s) Selected</WsTypography>
                </Grid>
              </Stack>
            </Grid>
            <Grid item pr={1}>
              <WsButton onClick={selectAllJobs}> Select All</WsButton>
            </Grid>
            <Grid item>
              <WsButton onClick={unSelectAllJobs}> UnSelect All</WsButton>
            </Grid>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack direction="row" justifyContent="flex-end">
            <Grid item pr={1}>
              <WsButton onClick={navigateToBulkPublish}>Post on Job Boards</WsButton>
            </Grid>
            {/* <Grid item pr={1}>
            <WsButton>Close Jobs</WsButton>
          </Grid> */}
            <Grid item pr={1}>
              <WsButton onClick={navigateToBulkJobsAssign}>Assign Recruiters</WsButton>
            </Grid>
            <Grid item pr={1}>
              <WsButton onClick={navigateToVendorBroadcast}>Broadcast Jobs to Vendors</WsButton>
            </Grid>
          </Stack>
        </Grid>
      </BottomActionBar>
    </ErrorBoundary>
  );
};

export default JobsBottomActionBar;
